<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { paginationProps } from './pagination'

defineOptions({
  name: 'VsPagination',
})

const props = defineProps(paginationProps)

// init here
</script>
